import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `FichaVerraco/addNuevoVerraco`, method: 'POST', body: values, token: token})
}
